<div id="masterbodypartswrapper" class="masterbodypartswrapper">
  <!-- Modern File Upload Section -->
  <div class="file-upload-section">
    <div class="upload-container">
      <!-- File Drop Zone -->
      <div *ngIf="!isFile" class="file-drop-zone"
        [ngClass]="isDragOver() ? 'dragover-active': ''"
      >
        <div id="drag-area"
          class="drag-area-content"
            (drop)="dropFile($event)"
            (dragover)="dragOverFile($event)"
            (dragleave)="dragLeaveFile($event)"
            (dragend)="dragEndFile($event)"
            >
          <div class="upload-icon">
            <img src="../../../assets/images/add_new.svg" alt="upload">
          </div>
          <h4>Drop your file here</h4>
          <p>or <button type="button" (click)="browseFile($event)" class="browse-button">Browse Files</button></p>
          <div class="file-formats">
            <span class="format-tag">CSV</span>
            <span class="format-tag">xls</span>
            <span class="format-tag">XLSX</span>
          </div>
                <input (change)="onFileChange($event)" accept=".csv,.xlsx,.xls" type="file" id="file-input" hidden>
            </div>
        </div> 

      <!-- File Uploaded State -->
      <div *ngIf="isFile" class="file-uploaded-state">
        <div class="file-info">
          <div class="file-icon">
            <img src="../../../assets/images/file.svg" alt="file">
      </div>
          <div class="file-details">
            <h4>{{ uploadedFile?.name }}</h4>
            <p>{{ (uploadedFile?.size / 1024).toFixed(1) }} KB</p>
          </div>
          <button (click)="resetFile()" class="remove-btn" title="Remove file">
            <img src="../../../assets/images/remove.svg" alt="remove">
          </button>
        </div>
      </div>

      <!-- Upload Actions -->
      <div class="upload-actions">
        <div class="file-requirements">
          <div class="requirement-item">
            <img src="../../../assets/images/information.svg" alt="info">
            <span>Required format: CSV</span>
          </div>
        </div>
        <button 
          class="upload-btn" 
          type="button" 
          [disabled]="!(isFile && fileType !== '')" 
          (click)="onSubmit()"
        >
          <img src="../../../assets/images/add_new.svg" alt="upload">
          Upload Body Parts
        </button>
      </div>
    </div>

    <!-- Template Download Section -->
    <div class="template-section">
      <div class="template-content">
        <h3>Need a template?</h3>
        <p>Download the CSV template to get started</p>
        <button class="template-btn" type="button" (click)="downloadBulkUploadTemplate(masterType)">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 12H1.5H2ZM2 4.00004H2.5H2ZM4.66667 1.33337V0.833374V1.33337ZM11.3333 1.33337V0.833374V1.33337ZM14 4.00004H13.5H14ZM14 8.2288H14.5H14ZM7.5621 14.6667V14.1667V14.6667ZM4.66667 14.6667V15.1667V14.6667ZM13.219 10.1144L12.8654 9.76087H12.8654L13.219 10.1144ZM9.44771 13.8857L9.80127 14.2392L9.44771 13.8857ZM8.66667 12H9.16667H8.66667ZM11.3333 9.33337V8.83337V9.33337ZM10.3536 6.35359C10.5488 6.15833 10.5488 5.84175 10.3536 5.64649C10.1583 5.45123 9.84171 5.45123 9.64645 5.64649L10.3536 6.35359ZM8.94281 7.05723L8.58926 6.70368L8.94281 7.05723ZM7.05719 7.05723L7.41075 6.70368H7.41075L7.05719 7.05723ZM6.35355 5.64649C6.15829 5.45122 5.84171 5.45122 5.64645 5.64649C5.45119 5.84175 5.45119 6.15833 5.64645 6.35359L6.35355 5.64649ZM7.5 7.33337C7.5 7.60952 7.72386 7.83337 8 7.83337C8.27614 7.83337 8.5 7.60952 8.5 7.33337H7.5ZM8.5 4.00004C8.5 3.7239 8.27614 3.50004 8 3.50004C7.72386 3.50004 7.5 3.7239 7.5 4.00004H8.5ZM2.5 12L2.5 4.00004H1.5L1.5 12H2.5ZM4.66667 1.83337L11.3333 1.83337V0.833374L4.66667 0.833374V1.83337ZM13.5 4.00004V8.2288H14.5V4.00004H13.5ZM7.5621 14.1667H4.66667V15.1667H7.5621V14.1667ZM12.8654 9.76087L9.09416 13.5321L9.80127 14.2392L13.5725 10.468L12.8654 9.76087ZM7.5621 15.1667C8.40195 15.1667 9.2074 14.8331 9.80127 14.2392L9.09416 13.5321C8.68783 13.9384 8.13673 14.1667 7.5621 14.1667V15.1667ZM13.5 8.2288C13.5 8.80344 13.2717 9.35454 12.8654 9.76087L13.5725 10.468C14.1664 9.87411 14.5 9.06866 14.5 8.2288H13.5ZM2.5 4.00004C2.5 2.80342 3.47005 1.83337 4.66667 1.83337V0.833374C2.91777 0.833374 1.5 2.25114 1.5 4.00004H2.5ZM1.5 12C1.5 13.7489 2.91776 15.1667 4.66667 15.1667V14.1667C3.47005 14.1667 2.5 13.1967 2.5 12H1.5ZM11.3333 1.83337C12.53 1.83337 13.5 2.80342 13.5 4.00004H14.5C14.5 2.25114 13.0822 0.833374 11.3333 0.833374V1.83337ZM9.16667 14.6667L9.16667 12H8.16667L8.16667 14.6667L9.16667 14.6667ZM11.3333 9.83337L14 9.83337L14 8.83337L11.3333 8.83337V9.83337ZM9.16667 12C9.16667 10.8034 10.1367 9.83337 11.3333 9.83337V8.83337C9.58443 8.83337 8.16667 10.2511 8.16667 12H9.16667ZM9.64645 5.64649L8.58926 6.70368L9.29636 7.41078L10.3536 6.35359L9.64645 5.64649ZM7.41075 6.70368L6.35355 5.64649L5.64645 6.35359L6.70364 7.41079L7.41075 6.70368ZM8.5 7.33337V4.00004H7.5V7.33337H8.5ZM8.58926 6.70368C8.26382 7.02911 7.73618 7.02911 7.41075 6.70368L6.70364 7.41078C7.4196 8.12675 8.5804 8.12675 9.29636 7.41078L8.58926 6.70368Z"/>
            </svg>
          Download Template
        </button>
        </div>
      </div> 
  </div>
  <!-- Modern Data Table Section -->
  <div class="data-table-section">
    <!-- Title and Record Summary Header -->
    <div class="title-summary-header mb-3">
      <h2 class="section-title">Body Parts - {{ totalBodyPartsCount }}</h2>
      <div class="record-summary-header" *ngIf="bodyparts && bodyparts.length > 0">
        <span class="record-count">{{ bodyparts.length }} records</span>
      </div>
        </div>
    
    <!-- Search and Filter Controls -->
    <div class="list-controls mb-3">
      <div class="controls-left">
        <div class="search-controls">
            <form class="search-block" (submit)="onSearchSubmit()">
                <div class="search-input">
                    <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by Body Part Name">
                </div>
                <button type="submit" class="icon-btn">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                    </svg>
                </button>
            </form> 
                            <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
        </div>
      </div>
      <div class="controls-right">
        <button class="add-btn" (click)="openDialog()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3.33333V12.6667M3.33333 8H12.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          Add Body Part
        </button>
        </div>
    </div>

    <!-- Data Table -->
    <div class="data-table" *ngIf="bodyparts && bodyparts.length > 0">
      <div class="table-header">
        <div class="header-cell">Name</div>
        <div class="header-cell">Type</div>
        <div class="header-cell actions">Actions</div>
      </div>
      
      <div class="table-row" *ngFor="let bodypart of bodyparts; let i = index" [ngClass]="{'alternate-row': i % 2 === 1}">
        <div class="table-cell">{{ bodypart.name }}</div>
        <div class="table-cell">{{ bodypart.type }}</div>
        <div class="table-cell actions">
          <div class="action-buttons">
            <button class="action-btn edit-btn" (click)="openEditDialog(bodypart)" title="Edit">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.3333 2L14 4.66667L5.33333 13.3333H2.66667V10.6667L11.3333 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="action-btn delete-btn" (click)="openDeleteDialog(bodypart)" title="Delete">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4H14M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31305 1.33333 6.66667 1.33333H9.33333C9.68696 1.33333 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31305 14.6667 3.97391 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4H12.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- No Results -->
    <div *ngIf="!bodyparts || bodyparts.length === 0" class="no-results">
      <div class="no-results-content">
        <img src="../../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
        <h2 class="header-2 mb-2">No body parts found</h2>
        <p class="text-para text-light-dark">Add your first body part to get started</p>
      </div>
    </div>
  </div>
  <div class="" *ngIf="paginationData?.totalPage > 1">
    <app-pagination [totalPages]="paginationData.totalPage" (queryPage)="getQueryPage($event)"></app-pagination>
  </div>
</div>


